import { useCallback, useMemo } from 'sb-hooks'
import { ModalVisibilityProps } from 'sb-modal'
import request from 'sb-request'
import { useForm } from 'formular'
import actions from 'redux/actions'
import { required } from 'helpers/validation'
import { snowplow } from 'common/helpers'

import messages from './messages'

import skipFeedbackQuery from './skipFeedback.graphql'


type SkipFeedbackVariables = {
  input: {
    holdId: number
    reason: string
    comment?: string
  }
}

const useSkipAMonthSuccessModal = (props: SkipAMonthSuccessModal.ModalProps & ModalVisibilityProps) => {
  const { skippedMonthCount, holdId, closeModal, onClose } = props

  const form = useForm<SkipAMonthSuccessModal.FormValues>({
    fields: {
      reason: [ required ],
      comments: [],
    },
    initialValues: {
      reason: '',
      comments: '',
    },
  })

  const reasons = useMemo<SkipAMonthSuccessModal.Reason[]>(() => ([
    {
      title: messages.reasonCost,
      value: messages.reasonCost.en,
      withComments: false,
    },
    {
      title: messages.reasonDontNeed,
      value: messages.reasonDontNeed.en,
      withComments: false,
    },
    {
      title: messages.reasonTakesLonger,
      value: messages.reasonTakesLonger.en,
      withComments: false,
    },
    {
      title: messages.reasonOther,
      value: messages.reasonOther.en,
      withComments: true,
    },
  ]), [])

  const onSubmit = useCallback(async () => {
    try {
      const { reason, comments } = await form.submit()

      snowplow.track('UF skip reason submit', { reason })

      actions.models.ui.showRequestLoader()

      // ATTN it's done for recurly
      if (holdId) {
        await request.gql<SkipFeedbackVariables, any>('skipFeedback', {
          body: {
            query: skipFeedbackQuery,
            variables: {
              input: {
                holdId,
                reason,
                comment: comments,
              },
            },
          },
          withNestedErrors: true,
        })
      }
      else {
        await new Promise((resolve) => setTimeout(resolve, 200))
      }

      actions.misc.notifications.show('alert', {
        title: messages.notificationTitle,
      })

      closeModal()
    }
    catch (error) {
      console.error(error)
    }
    finally {
      actions.models.ui.hideRequestLoader()
    }
  }, [ closeModal, form, holdId ])

  return {
    skippedMonthCount,
    reasons,
    form,
    onSubmit,
    onClose,
  }
}


export default useSkipAMonthSuccessModal
